import React, { Component } from 'react';
import { getLocalizedValue } from 'src/utils/helpers';
import i18n from 'src/i18n';
import moment from 'moment';
import NavigationArrowDownward from 'material-ui/svg-icons/navigation/arrow-downward';
import autoBind from 'react-autobind';
import IconButton from 'material-ui/IconButton';
import { List, ListItem } from 'material-ui/List';
import Avatar from 'material-ui/Avatar';
import { blue500 } from 'material-ui/styles/colors';
import NotificationsIcon from 'material-ui/svg-icons/social/notifications';
import Subheader from 'material-ui/Subheader';
import { AvLibraryBooks } from 'material-ui/svg-icons';

class OperatorNotificationList extends Component {
    constructor(props) {
        super(props);
        autoBind(this);

        this.state = {
            activeContent: null,
        };
    }

    render() {
        const { notifications, t, title } = this.props;

        if (notifications.length === 0)
            return <Subheader>{t('operator_notifications.modal.no_notifications_title', { title })}</Subheader>;

        return (
            <>
                <Subheader>{title}</Subheader>
                <div className="row">
                    <List>{notifications.map(notification => this.renderNotification(notification))}</List>
                </div>
            </>
        );
    }

    renderNotification(notification) {
        const isExpanded = this.state.activeContent === notification.id;
        const { t, title } = this.props;

        console.log(notification, 'notification');
        return (
            <div
                key={notification.id}
                className={`bf-notification-content-item ${isExpanded ? 'is-expanded' : ''}`}
                onClick={() => this.setState({ activeContent: isExpanded ? null : notification.id })}
                style={{ width: '100%' }}>
                <ListItem
                    key={notification.id}
                    style={{ width: '100%' }}
                    className={`bf-notification-list-item ${isExpanded ? 'is-expanded' : ''}`}
                    leftAvatar={
                        <Avatar
                            icon={notification.type === 'NEWSLETTER' ? <AvLibraryBooks /> : <NotificationsIcon />}
                            backgroundColor={blue500}
                        />
                    }
                    primaryText={
                        <span
                            dangerouslySetInnerHTML={{ __html: getLocalizedValue(notification.title, i18n.language) }}
                        />
                    }
                    secondaryText={t('operator_notifications.modal.released', {
                        date: moment(notification.createdAt).format('DD.MM.YYYY'),
                    })}
                    rightIconButton={
                        <IconButton
                            size="small"
                            color="primary"
                            onClick={() => this.setState({ activeContent: isExpanded ? null : notification.id })}>
                            <NavigationArrowDownward className="bf-arrow-icon" size="small" />
                        </IconButton>
                    }></ListItem>
                <div className="bf-notification-content-body">
                    <div className="bf-notification-body-inner">
                        <div
                            dangerouslySetInnerHTML={{ __html: getLocalizedValue(notification.text, i18n.language) }}
                        />
                    </div>
                </div>
            </div>
        );
    }
}

export default OperatorNotificationList;
